import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import React, { useState } from "react";
import ReactSVG from "react-svg";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Loader } from "@components/atoms";
import { TextField } from "@components/molecules";
import { useDelivery } from "@saleor/sdk/";
import { errorMessage } from "@temp/intl";
import { addListInProgress, useAppDispatch } from "@temp/redux";
import * as S from "./styles";

var closeWhite = require("../../images/closewhite.svg");

export var AlertAssingOrder = function AlertAssingOrder(_ref) {
  var _errors$error, _errors$error2, _errors$error2$graphQ, _errors$error3, _errors$error3$graphQ, _errors$error4, _errors$error5;

  var hideModal = _ref.hideModal;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      orderId = _useState2[0],
      setOrderId = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      errors = _useState4[0],
      setErrors = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var intl = useIntl();

  var _useDelivery = useDelivery(),
      autoAssingOrder = _useDelivery.autoAssingOrder;

  var dispatch = useAppDispatch();

  var handleAutoAssingOrder = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(orderId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);

              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(position) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            handleMutationAutoAssingOrder(orderId, position);

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }(), function (error) {
                  switch (error.code) {
                    case error.PERMISSION_DENIED:
                      handleMutationAutoAssingOrder(orderId, undefined, "PERMISSION_DENIED");
                      break;

                    case error.POSITION_UNAVAILABLE:
                      handleMutationAutoAssingOrder(orderId, undefined, "POSITION_UNAVAILABLE");
                      break;

                    case error.TIMEOUT:
                      handleMutationAutoAssingOrder(orderId, undefined, "TIMEOUT");
                      break;

                    default:
                      handleMutationAutoAssingOrder(orderId, undefined, "ERROR_UNKNOWN");
                  }
                }, {
                  enableHighAccuracy: true,
                  timeout: 7000
                });
              } else {
                handleMutationAutoAssingOrder(orderId, undefined, "ERROR_UNKNOWN");
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleAutoAssingOrder(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleMutationAutoAssingOrder = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(orderId, position, reasonNoLocation) {
      var _position$coords, _position$coords2, _position$coords3;

      var _yield$autoAssingOrde, data, dataError;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return autoAssingOrder(window.btoa("Order:".concat(orderId)), {
                latitude: (position === null || position === void 0 ? void 0 : (_position$coords = position.coords) === null || _position$coords === void 0 ? void 0 : _position$coords.latitude) ? Number(position.coords.latitude.toFixed(5)) : null,
                longitude: (position === null || position === void 0 ? void 0 : (_position$coords2 = position.coords) === null || _position$coords2 === void 0 ? void 0 : _position$coords2.longitude) ? Number(position.coords.longitude.toFixed(5)) : null,
                accuracy: (position === null || position === void 0 ? void 0 : (_position$coords3 = position.coords) === null || _position$coords3 === void 0 ? void 0 : _position$coords3.accuracy) ? Number(position.coords.accuracy.toFixed(5)) : null,
                reasonNoLocation: reasonNoLocation || null
              });

            case 2:
              _yield$autoAssingOrde = _context3.sent;
              data = _yield$autoAssingOrde.data;
              dataError = _yield$autoAssingOrde.dataError;

              if (dataError) {
                setLoading(false);
                setErrors(dataError);
              } else {
                dispatch(addListInProgress({
                  data: {
                    node: data
                  }
                }));
                hideModal();
                setLoading(false);
              }

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleMutationAutoAssingOrder(_x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  var assingOrder = function assingOrder() {
    if (orderId.trim().length >= 1) {
      handleAutoAssingOrder(orderId);
    }
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "showAlertAssingOrder"
  }), React.createElement("div", {
    className: "showAlertAssingOrder__data"
  }, React.createElement("div", {
    className: "showAlertAssingOrder__data__close"
  }, React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.AlertAssingOrder.index.3896099556",
    defaultMessage: "Assign me order"
  })), React.createElement(ReactSVG, {
    path: closeWhite,
    onClick: hideModal
  })), React.createElement("div", {
    className: "showAlertAssingOrder__data__content  showAlertAssingOrder__data__content--amount showAlertAssingOrder__data__content--first showAlertAssingOrder__data__content--last"
  }, React.createElement(TextField, {
    name: "order_code",
    type: "number",
    autoFocus: true,
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Code",
      "id": "components.AlertAssingOrder.index.78726751"
    }, "id", "components.AlertAssingOrder.index.78726751")),
    onChange: function onChange(e) {
      if (e.target.value.length <= 140) {
        setOrderId(e.target.value);
      }
    },
    autoComplete: "order_coder",
    placeholder: intl.formatMessage(_defineProperty({
      defaultMessage: "Ex: 2546",
      "id": "components.AlertAssingOrder.index.3215542667"
    }, "id", "components.AlertAssingOrder.index.3215542667")),
    inputMode: "numeric"
  }), errors && (errors === null || errors === void 0 ? void 0 : errors.error) && (errors === null || errors === void 0 ? void 0 : (_errors$error = errors.error) === null || _errors$error === void 0 ? void 0 : _errors$error.graphQLErrors) && (errors === null || errors === void 0 ? void 0 : (_errors$error2 = errors.error) === null || _errors$error2 === void 0 ? void 0 : (_errors$error2$graphQ = _errors$error2.graphQLErrors) === null || _errors$error2$graphQ === void 0 ? void 0 : _errors$error2$graphQ.length) > 0 ? React.createElement("div", {
    className: "showAlertAssingOrder__data__content"
  }, React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.AlertAssingOrder.index.3555649182",
    defaultMessage: "Something unexpected has occurred, please try again"
  })), React.createElement("div", null, errors === null || errors === void 0 ? void 0 : (_errors$error3 = errors.error) === null || _errors$error3 === void 0 ? void 0 : (_errors$error3$graphQ = _errors$error3.graphQLErrors) === null || _errors$error3$graphQ === void 0 ? void 0 : _errors$error3$graphQ.map(function (error, index) {
    return React.createElement("p", {
      key: index
    }, React.createElement(FormattedMessage, {
      id: "components.AlertAssingOrder.index.2327933566",
      defaultMessage: "Details:"
    }), " ", error === null || error === void 0 ? void 0 : error.message);
  }))) : errors && (errors === null || errors === void 0 ? void 0 : errors.error) && !(errors === null || errors === void 0 ? void 0 : (_errors$error4 = errors.error) === null || _errors$error4 === void 0 ? void 0 : _errors$error4.graphQLErrors) && (errors === null || errors === void 0 ? void 0 : (_errors$error5 = errors.error) === null || _errors$error5 === void 0 ? void 0 : _errors$error5.map(function (error, index) {
    return React.createElement("div", {
      key: index,
      className: "showAlertAssingOrder__data__content"
    }, (error === null || error === void 0 ? void 0 : error.code) === "NOT_FOUND" && (error === null || error === void 0 ? void 0 : error.field) === "id" ? React.createElement("p", null, React.createElement(FormattedMessage, {
      id: "components.AlertAssingOrder.index.362811410",
      defaultMessage: "The order with the entered code does not exist"
    })) : (error === null || error === void 0 ? void 0 : error.code) === "MAXIMUM_ASSIGNED_ORDERS_EXCEEDED" ? React.createElement("p", null, intl.formatMessage(errorMessage.limitAssignedOrders, {
      maxDeliveryOrders: error === null || error === void 0 ? void 0 : error.maxDeliveryOrders
    })) : React.createElement("p", null, React.createElement(FormattedMessage, {
      id: "components.AlertAssingOrder.index.1979806601",
      defaultMessage: "This order cannot be assigned"
    })));
  }))), React.createElement("div", {
    className: "showAlertAssingOrder__data__footer"
  }, React.createElement(Button, {
    type: "button",
    testingContext: "",
    onClick: assingOrder
  }, React.createElement(FormattedMessage, {
    id: "components.AlertAssingOrder.index.3099637318",
    defaultMessage: "Assing"
  })))), loading && React.createElement(S.WrapperTransparentLoader, null, React.createElement(Loader, null)));
};
export default AlertAssingOrder;